// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.successMessage_successMessage__vFsOJ {
    border: 1px solid #007bff;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 20px;
    font-size: 14px;
    color: #007bff;
    border-radius: 4px;
    background: #fff;
    text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/_components/successMessage/successMessage.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B","sourcesContent":[".successMessage {\n    border: 1px solid #007bff;\n    padding: 10px 20px;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    font-size: 14px;\n    color: #007bff;\n    border-radius: 4px;\n    background: #fff;\n    text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"successMessage": `successMessage_successMessage__vFsOJ`
};
export default ___CSS_LOADER_EXPORT___;
